import { Component, Inject, NgZone, PLATFORM_ID, Output } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import { UniqueLogUsersPerDate } from '../model/UniqueLogUsersPerDate';
import { Log } from '@src/app/models/log';
import { AdminService } from '../service/admin.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-uniquelogincounter',
  templateUrl: './uniquelogincounter.component.html',
  styleUrls: ['./uniquelogincounter.component.css']
})
export class UniquelogincounterComponent {
  private root!: am5.Root;
  logs: Log[];
  @Output() uniquenumber: number;
  uniqueLogs: UniqueLogUsersPerDate[];
  constructor(@Inject(PLATFORM_ID) private platformId: Object, private zone: NgZone, private as: AdminService) {}


  // Run the function only in the browser
  browserOnly(f: () => void) {
    if (isPlatformBrowser(this.platformId)) {
      this.zone.runOutsideAngular(() => {
        f();
      });
    }
  }
  countUniqueLogUsersPerDate(logs: Log[]): UniqueLogUsersPerDate[] {
    const uniqueLogUsersPerDate: UniqueLogUsersPerDate[] = [];
    const logUsersPerDate = new Map<string, Set<string>>(); // Map of date to Set of unique log users

    // Iterate through the logs and group log users by date
    for (const log of logs) {
      const date = log.timeISO.substring(0, 10);
      if (!logUsersPerDate.has(date)) {
        logUsersPerDate.set(date, new Set<string>());
      }
      logUsersPerDate.get(date)?.add(log.loguser);
    }

    // Iterate through the grouped log users and count the number of unique users per date
    for (const [date, users] of logUsersPerDate) {
      uniqueLogUsersPerDate.push({
        date: (new Date(date).getTime()),
        value: users.size,
      });
    }
    //console.log('Unque Counter Numbers',uniqueLogUsersPerDate);
    return uniqueLogUsersPerDate;
  }
  ngAfterViewInit() {
    var from = new Date();
    from.setDate(from.getDate() - 10);
    var to = new Date();
    this.as.getLogs(from.toISOString(), to.toISOString()).pipe(untilDestroyed(this)).subscribe(data => {
      this.logs = data;
      for (var log of this.logs) {
        if (sessionStorage.getItem('person_' + log.loguser)) {
          log.loguser = JSON.parse(sessionStorage.getItem('person_' + log.loguser)).fullname;

        } else {
          this.as.getPerson(log.loguser).pipe(untilDestroyed(this)).subscribe(person => {
            sessionStorage.setItem('person_' + log.loguser, JSON.stringify(person));
            log.loguser = person.fullname;
          });
        }
      }
      this.uniqueLogs = this.countUniqueLogUsersPerDate(this.logs);
    //  //console.log('Unique LogIns Per date: ', this.uniqueLogs);
      this.uniquenumber = this.uniqueLogs.length;
    //  //console.log('uniquenumber', this.uniqueLogs.length)
    });
  }}
